import {PaydaySymbol} from "./symbols/PaydaySymbol";
import {gsap} from "gsap"
import {Payday} from "../Payday";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class HorizontalReel extends PIXI.Container {

    public symbolContainers:PaydaySymbol[] = [];

    public stepDelta:number = 0;
    public spinTimeline:gsap.core.Timeline;

    public symbolCount:number;
    public symbolWidth:number;
    public stepDuration:number;

    public isQuickStop = false;

    public isFreespin = false;
    public BASE_GAME_REELS = [
        "2","SC","0","4","0","0","100","2","20","2","2","4","0","20","10","0","10","1000","0","0",
        "10","4","10000","0","50","0","100","100","0","4","0","SC","0","4","0","100","0","0","50","50",
        "SC","0","10","2","0","100","10","1000","50","1000","0","0","20","10","50","10","20","0","0","4",
        "2","20","4","10","10000","0","2","2","0","20","2","50","SC","0","1000","10","2","2","4","1000",
        "0","4","10","100","20","0","4","4","20","50","0","2","0","0","SC","10000","0","10000"
    ];
    public FREESPIN_REELS = [
        "20","4","1000","50","10","10000","20","4","10","10","1000","10","100","SC","10000","SC","10000","10","SC",
        "20","100","50","10","10","10","20","4","50","4","20","50","20","1000","50","10","1000","10000","50","100",
        "50","4","SC","100","100","4","100","4","4","1000","20","4","4","SC","4","20","10"
    ];

    constructor(symbolCount:number, symbolWidth:number, stepDuration:number) {
        super();
        this.symbolCount = symbolCount;
        this.symbolWidth = symbolWidth;
        this.stepDuration = stepDuration;

        const startingSymbols = Payday.model.initData.reels.concat(["0"]);
        for (let i = 0; i < this.symbolCount + 1; i++) {
            const newSymbol = new PaydaySymbol(startingSymbols[i]);
            newSymbol.position.x = i * this.symbolWidth;
            this.addChild(newSymbol);
            this.symbolContainers.push(newSymbol);
        }

        this.spinTimeline = gsap.timeline({onUpdate: () => {
                this.symbolContainers.forEach((symbol, index) => {
                    symbol.position.x = index * this.symbolWidth + this.stepDelta * this.symbolWidth;
                });
            }})
            .add(gsap.to(this, {stepDelta: 1, duration: this.stepDuration, ease:"none"}))
            .add(() => {
                this.stepDelta = 0;
                const newSymbol = new PaydaySymbol(this.randomSymbol());
                newSymbol.setSpinning(true);
                this.symbolContainers.unshift(newSymbol);
                this.addChild(newSymbol);
                this.removeChild(this.symbolContainers.pop()!);
            });
        this.spinTimeline.repeat(0);
        this.spinTimeline.progress(1, false);
    }

    public start() {
        this.isQuickStop = Payday.apiPlugin.settings.get(APISetting.FAST_SPIN);
        this.spinTimeline.timeScale(this.isQuickStop ? 2 : 1);
        return gsap.timeline().add(() => {
            this.symbolContainers.forEach((symbol) => {
                symbol.setSpinning(false);
            })
            this.spinTimeline.progress(0);
            this.spinTimeline.repeat(-1);
        });
    }

    public stop(symbols:string[]) {
        return gsap.timeline()
            .add(() => {
                this.spinTimeline.repeat(0);
                this.spinTimeline.eventCallback("onComplete", () => {
                    const bruh = this.actuallyStop(["0"].concat(symbols));
                    if (this.isQuickStop)
                        bruh.timeScale(2);
                })
            })
            .add(() => {this.symbolContainers.forEach((sym) => sym.setStill())}, 0.5)
            .add(() => {}, '>0.3')
    }

    private actuallyStop(symbols:string[]) {
        const stopTimeline = gsap.timeline({onUpdate: () => {
                this.symbolContainers.forEach((symbol, index) => {
                    symbol.position.x = index * this.symbolWidth + this.stepDelta * this.symbolWidth;
                });
            },
            onComplete: () => {
                const obamna = gsap.timeline()
                    .add(this.symbolContainers
                        .map((sym, index) => gsap.to(sym, {duration: 0.125, x: (index + 0.75) * this.symbolWidth })))
                    .add(this.symbolContainers
                        .map((sym, index) => gsap.to(sym, {duration: 0.125, x: (index) * this.symbolWidth })))
                if (this.isQuickStop)
                    obamna.timeScale(2);
            }})
            .add(gsap.to(this, {stepDelta: 1, duration: this.stepDuration, ease:"none"}))
            .add(() => {
                this.stepDelta = 0;
                const newSymbol = new PaydaySymbol(symbols.pop()!);
                newSymbol.setSpinning(true);
                this.symbolContainers.unshift(newSymbol);
                this.addChild(newSymbol);
                this.removeChild(this.symbolContainers.pop()!);
            });
        stopTimeline.repeat(9);
        return stopTimeline;
    }

    private randomSymbol():string {
        const reelSet = this.isFreespin ? this.FREESPIN_REELS : this.BASE_GAME_REELS;
        return reelSet[Math.floor(Math.random() * reelSet.length)];
    }

    public setToBaseGame() {
        this.isFreespin = false;
    }

    public setToFreespins() {
        this.isFreespin = true;
    }
}